import {WixSdk} from '@wix/js-sdk-wrapper';

export const getInstanceId = () => {
  return WixSdk.Utils.getInstanceId();
};
